// Authentication Action Types

export const GOOGLE_LOGGED_IN = 'GOOGLE_LOGGED_IN';
export const GOOGLE_LOGGED_OUT = 'GOOGLE_LOGGED_OUT';
export const GOOGLE_CLIENT_READY = 'GOOGLE_CLIENT_READY';

export const STEAM_SET_ID = 'STEAM_SET_ID';
export const STEAM_SET_API_KEY = 'STEAM_SET_API_KEY';
export const STEAM_SET_PROFILE = 'STEAM_SET_PROFILE';
export const STEAM_LOGGED = 'STEAM_LOGGED';
export const STEAM_LOAD = 'STEAM_LOAD';
export const STEAM_SET_OWNED_GAMES = 'STEAM_SET_OWNED_GAMES';

export const ITAD_SET_MAP = 'ITAD_SET_MAP';

export const SPREADSHEET_SET_ID = 'SPREADSHEET_SET_ID';
export const SET_CURRENT_SPREADSHEET_ID = 'SET_CURRENT_SPREADSHEET_ID';
export const SET_CURRENT_SHEET_ID = 'SET_CURRENT_SHEET_ID';
export const SET_UP_COMPLETE = 'SET_UP_COMPLETE';
export const SET_SPREADSHEET_PERMISSION = 'SET_SPREADSHEET_PERMISSION';